import { RootState } from '../store';

const filters = (state: RootState) => state.filters;

export const getFilters = (state: RootState) => filters(state).filters;
export const getActiveFilters = (state: RootState) =>
  filters(state).activeFilterQuery;

export const getOptions = (state: RootState) => state.filters.options;
